const asyncDispatchMiddleware = store => next => {
    const asyncDispatch = action => Promise.resolve().then( () => store.dispatch( action ) );
    return action => next( { ...action, asyncDispatch } );
};

export default asyncDispatchMiddleware;
